import styled from "@emotion/styled";
import React, { useEffect, useRef, useState } from "react";

import { useTicketPackageList } from "@src/hooks/deungi/useTicketPackageList";
import { TicketPackageListResponseDto } from "@src/hooks/deungi/dto/PackageList.dto";

import { transferToNative } from "@src/lib/WebAppBridge";

import { css } from "@emotion/react";
import { checkDevice } from "@src/components/deungi/common/utils";
import { PRODUCT_SALE_TYPE, TICKET_TYPE, TICKET_TYPE_STRING } from "@src/components/deungi/common/enum";

import PackageCard from "@src/components/deungi/DeungiPackageCard";

import auction_agent_with_consulting_ticket_ico from "@src/assets/expert/ticket/agentIcon.png";
import auction_agent_ticket_ico from "@src/assets/expert/ticket/agent2Icon.png";
import ExpertTicketBox from "@src/components/expert/ticket/ExpertTicketBox";
import ExpertPaymentInfoBox from "@src/components/expert/ticket/ExpertPaymentInfoBox";
import { PackageListBoxStyle, TicketContainer } from "./ExpertCompanionPackageListBox";
import CommonTicketItem from "@src/components/expert/ticket/CommonTicketItem";
import CommonPackageListBox from "./CommonPackageListBox";
import { useSearchParams } from "react-router-dom";

const ExpertAgentPackageListBox = () => {
    const [searchParams] = useSearchParams();
    const isOnlyBidAgent = searchParams.get("isOnlyBidAgent") === "1";
    if (isOnlyBidAgent) {
        return (
            <Container>
                <TicketContainer>
                    <CommonTicketItem
                        ticketTypeNumber={TICKET_TYPE.AUCTION_AGENT_TICKET}
                        ticketTitle="매수신청대리 매칭 이용권"
                        ticketImage={auction_agent_ticket_ico}
                    />
                </TicketContainer>
                <PackageListBoxStyle>
                    <CommonPackageListBox
                        ticketTypeString={TICKET_TYPE_STRING.AUCTION_AGENT_TICKET}
                        ticketTitle="전문가 매칭 이용권"
                        ticketImage={auction_agent_ticket_ico}
                    />
                </PackageListBoxStyle>
                <ExpertPaymentInfoBox ticketType={TICKET_TYPE_STRING.AUCTION_AGENT_TICKET} title="매수신청대리 매칭 이용권" />
            </Container>
        );
    }
    return (
        <Container>
            <TicketContainer>
                <CommonTicketItem
                    ticketTypeNumber={TICKET_TYPE.AUCTION_AGENT_WITH_CONSULTING_TICKET}
                    ticketTitle="경매대행 매칭 이용권 (매물컨설팅 + 매수신청대리)"
                    ticketImage={auction_agent_with_consulting_ticket_ico}
                />
            </TicketContainer>
            <PackageListBoxStyle>
                <CommonPackageListBox
                    ticketTypeString={TICKET_TYPE_STRING.AUCTION_AGENT_WITH_CONSULTING_TICKET}
                    ticketTitle="전문가 매칭 이용권"
                    ticketImage={auction_agent_with_consulting_ticket_ico}
                />
            </PackageListBoxStyle>
            <ExpertPaymentInfoBox
                ticketType={TICKET_TYPE_STRING.AUCTION_AGENT_WITH_CONSULTING_TICKET}
                title="전문가 매칭 이용권"
            />
        </Container>
    );
};

const Container = styled.div`
    height: 100%;
    overflow: scroll;
    background-color: white;
    .backDiv {
        width: 0;
        height: 75px;
    }
`;

export default ExpertAgentPackageListBox;
